import { render, staticRenderFns } from "./UserDetailsView.vue?vue&type=template&id=755249c2"
import script from "./UserDetailsView.vue?vue&type=script&lang=js"
export * from "./UserDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports